import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {Dossiers, ExportExcelParams} from '../index';
import {environment} from '@Env/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {DecisionEnum} from '../workflow/decision-commission.enum';

/**
 * Dossiers service pour la gestion des dossiers par les différents rôles
 */
@Injectable({ providedIn: 'root' })
export class DarDossiersGestService extends DaoGeneric<Dossiers> {
  private url = `${environment.baseUrl}/dar/dossiers/demandes_a_traiter/`;

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  public getDecision(dossier: Dossiers) {
    if (! dossier.decision_commission) {
      return '';
    }

    switch (dossier.decision_commission) {
      case DecisionEnum.validee:
        return 'Validée';
      case DecisionEnum.validee_partiellement:
        return 'Validée partiellement';
      case DecisionEnum.refus:
        return 'Refusée';
    }
  }

  /**
   * Export Excel des demandes
   */
  public exportExcel(exportParams: ExportExcelParams = null) {
    const url = `${environment.baseUrl}/dar/dossiers/export_excel/`;

    let params = new HttpParams();
    if (exportParams?.owner) {
      params = params.set('owner', exportParams.owner.uid)
    }
    if (exportParams?.by_date_range) {
      params = params.set('by_date_range', exportParams.by_date_range)
    }
    // params = params.set('template_name', templateName).set('file_name', fileName);

    return this.httpClient.get(url, {
      params,
      responseType: 'blob'
    }).pipe(map((data: any) => new Blob([data])));
  }
}
